/**
 * Two different questions, one file.
 *
 * Operational: did the coverage review land on `accepted`? Host publish uses
 * that as the Qualitas-path substitute for an uploaded póliza. Own-policy
 * cars were never supposed to enter that review, but submit still fires it
 * as best-effort, so `accepted` is not by itself a guest-facing Qualitas
 * claim.
 *
 * Guest-facing: may this screen say "Verificación ASR / Qualitas"? That
 * names the insurer as having verified THIS car. The same rule as checkout:
 * do not name Qualitas on a product surface that implies coverage until
 * policies are issued (`isCoveragePartnerBrandingVisible`). Own-policy and
 * no-policy cars never get that sentence.
 */
import { isCoveragePartnerBrandingVisible } from '../config/insurance-partners'

export const QUALITAS_ASR_ACCEPTED = 'accepted'

/**
 * Does THIS VEHICLE's trip carry platform (Qualitas) coverage?
 *
 * ONE PREDICATE, THREE ENFORCERS, ALL READING THE VEHICLE — not the premium the
 * client wrote:
 *   - `create-payment`'s authoritative charge (`insuranceCents > 0` ⟺ AML owed)
 *   - the rental INSERT trigger (`booking_eligibility(NEW.guest_id, ...)`)
 *   - this client predicate (the screens' premium line and the guest AML gate)
 * A persona-natural vehicle with an accepted platform review carries the
 * premium; own-policy, exempt and org vehicles carry zero, and nobody asks them
 * for the Qualitas declaration.
 */
export function vehicleHasPlatformCoverage(vehicle: {
  organizationId?: string | null
  coveragePath?: string | null
  coverageReviewStatus?: string | null
}): boolean {
  return (
    vehicle.organizationId == null &&
    vehicle.coveragePath === 'platform' &&
    vehicle.coverageReviewStatus === QUALITAS_ASR_ACCEPTED
  )
}

export function vehicleCoverageReviewAccepted(vehicle: {
  coverageReviewStatus?: string | null
}): boolean {
  return vehicle.coverageReviewStatus === QUALITAS_ASR_ACCEPTED
}

export function vehicleHasQualitasAsrVerification(vehicle: {
  coverageReviewStatus?: string | null
  hasOwnPolicyCoverage?: boolean | null
}): boolean {
  if (!isCoveragePartnerBrandingVisible()) return false
  if (vehicle.hasOwnPolicyCoverage) return false
  return vehicleCoverageReviewAccepted(vehicle)
}
